import { message } from 'antd';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { addGroupMemberAPI, addUpdateGroupAPI, fetchAllGroupsAPI, fetchGroupMembersAPI, fetchUnassignedGroupMembersAPI, removeGroupMemberAPI } from '../../../services/groups-service';
import { ADD_GROUP_MEMBER, ADD_GROUP_MEMBER_SUCCESS, ADD_UPDATE_GROUP, ADD_UPDATE_GROUP_SUCCESS, FETCH_ALL_GROUPS, FETCH_ALL_GROUPS_ERROR, FETCH_ALL_GROUPS_START, FETCH_ALL_GROUPS_SUCCESS, FETCH_ALL_GROUP_MEMBERS, FETCH_ALL_GROUP_MEMBERS_ERROR, FETCH_ALL_GROUP_MEMBERS_START, FETCH_ALL_GROUP_MEMBERS_SUCCESS, FETCH_UNASSIGNED_GROUP_MEMBERS, FETCH_UNASSIGNED_GROUP_MEMBERS_ERROR, FETCH_UNASSIGNED_GROUP_MEMBERS_SUCCESS, REMOVE_GROUP_MEMBER, REMOVE_GROUP_MEMBER_SUCCESS, SET_ALL_GROUPS_PAGINATION } from '../../actions/admin/groupsActions';
import { HIDE_MODAL, SUBMIT_ERROR, SUBMIT_START } from '../../actions/admin/modalActions';

// function* fetchUnassignedGroups({ userId }) {
//     try {
//         yield put({ type: FETCH_UNASSIGNED_GROUPS_START })
//         const response = yield call(fetchAllUnassignedGroupsAPI, userId);
//         if (response.success) {
//             yield put({ type: FETCH_UNASSIGNED_GROUPS_SUCCESS, groups: response.groups })
//         } else {
//             yield put({ type: FETCH_UNASSIGNED_GROUPS_ERROR, error: response.error })
//             message.error('Failed to fetch groups!');
//         }
//     } catch (error) {
//         yield put({ type: FETCH_UNASSIGNED_GROUPS_ERROR, error })
//         message.error('Failed to fetch groups!');
//     }
// }

function* fetchAllGroups({ payload }) {
    try {
        yield put({
            type: FETCH_ALL_GROUPS_START
        })
        const response = yield call(fetchAllGroupsAPI, payload);

        if (response.success) {
            const pagination = {
                currentPage: payload.pageNo,
                pageSize: payload.pageSize,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: SET_ALL_GROUPS_PAGINATION, pagination });
            yield put({
                type: FETCH_ALL_GROUPS_SUCCESS,
                groups: response.data.groups.length > 0 ? [...response.data.groups] : []
            })
        } else {
            yield put({ type: FETCH_ALL_GROUPS_ERROR })
            message.error('Failed to fetch groups!');
        }
    } catch (error) {
        yield put({ type: FETCH_ALL_GROUPS_ERROR, error })
        message.error('Failed to fetch groups!');
    }
}
function* fetchGroupMembers({ payload }) {

    try {
        yield put({ type: FETCH_ALL_GROUP_MEMBERS_START })
        const response = yield call(fetchGroupMembersAPI, payload);

        if (response.success) {
            yield put({
                type: FETCH_ALL_GROUP_MEMBERS_SUCCESS,
                groupMembers: response.data.length > 0 ? [...response.data] : []
            })
        } else {
            yield put({ type: FETCH_ALL_GROUP_MEMBERS_ERROR })
            message.error('Failed to fetch group members!');
        }
    }
    catch (error) {
        yield put({ type: FETCH_ALL_GROUP_MEMBERS_ERROR, error })
        message.error('Failed to fetch group members!');
    }
}
function* addUpdateGroup({ payload }) {
    try {
        yield put({ type: SUBMIT_START });
        const response = yield call(addUpdateGroupAPI, payload);
        if (response.success) {
            yield put({
                type: HIDE_MODAL,
            })
            yield put({
                type: ADD_UPDATE_GROUP_SUCCESS,
                group: response.data
            })
            if (payload.groupId == 0) {
                message.success('Added group successfully.');
            } else {
                message.success('Updated group successfully.');
            }

        } else {
            yield put({ type: SUBMIT_ERROR });
            message.error('Failed to add group!');
        }
    }
    catch (error) {
        yield put({ type: SUBMIT_ERROR });
        message.error('Failed to add group!');
    }
}

function* fetchUnassignedGroupMembers({ payload }) {

    try {
        const response = yield call(fetchUnassignedGroupMembersAPI, payload);
        if (response.success) {
            yield put({
                type: FETCH_UNASSIGNED_GROUP_MEMBERS_SUCCESS,
                unassignedGroupMembers: response.data.length > 0 ? [...response.data] : []
            })
        } else {
            yield put({ type: FETCH_UNASSIGNED_GROUP_MEMBERS_ERROR })
            message.error('Failed to fetch unassingned group members!');
        }
    }
    catch (error) {
        yield put({ type: FETCH_UNASSIGNED_GROUP_MEMBERS_ERROR, error })
        message.error('Failed to fetch unassingned group members!');
    }
}


function* addGroupMember({ payload }) {

    try {
        const response = yield call(addGroupMemberAPI, payload);
        if (response.success) {
            message.success('Added group member successfully.');
            yield put({
                type: ADD_GROUP_MEMBER_SUCCESS,
                groupMember: { ...response.data }
            })
        } else {
            message.error('Failed to add group member!');
        }
    }
    catch (error) {
        yield put({ type: FETCH_UNASSIGNED_GROUP_MEMBERS_ERROR, error })
        message.error('Failed to add group member!');
    }
}


function* removeGroupMember({ payload }) {

    try {
        const response = yield call(removeGroupMemberAPI, payload);
        if (response.success) {
            message.success('Removed group member successfully.');
            yield put({
                type: REMOVE_GROUP_MEMBER_SUCCESS,
                payload: payload
            })

        } else {
            message.error('Failed to remove group member!');
        }
    }
    catch (error) {
        message.error('Failed to remove group member!');
    }
}

function* groupsWatcher() {
    // yield takeEvery(FETCH_UNASSIGNED_GROUPS, fetchUnassignedGroups)
    yield takeLatest(FETCH_ALL_GROUPS, fetchAllGroups)
    yield takeLatest(FETCH_ALL_GROUP_MEMBERS, fetchGroupMembers)
    yield takeLatest(ADD_UPDATE_GROUP, addUpdateGroup)
    yield takeLatest(FETCH_UNASSIGNED_GROUP_MEMBERS, fetchUnassignedGroupMembers)
    yield takeLatest(ADD_GROUP_MEMBER, addGroupMember)
    yield takeLatest(REMOVE_GROUP_MEMBER, removeGroupMember)

}

export default function* rootSaga() {
    yield all([
        groupsWatcher()
    ]);
}